export const getDatePlusDays = (date: Date, days: number) => {
  const ret = new Date(date);
  ret.setDate(ret.getDate() + days);
  return ret;
};
